import { render } from "./FacilityLoginActionPopover.vue?vue&type=template&id=2a9e4ca0&ts=true"
import script from "./FacilityLoginActionPopover.vue?vue&type=script&lang=ts"
export * from "./FacilityLoginActionPopover.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__